import ImageTextColumnBlockPreview from "./ImageTextColumnBlockPreview";

export default ImageTextColumnBlockPreview;